import React, {Fragment, PureComponent} from "react";
import {withRouter} from 'react-router-dom';
import PropTypes from "prop-types";

import Typography from "@material-ui/core/Typography";
import Box from '@material-ui/core/Box';
import Grid from "@material-ui/core/Grid";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import {useMatomo} from '@datapunt/matomo-tracker-react';

import getViewData from "./data/ViewReader";
import headViewData from "./data/ViewReaderWithHeadRequest";
import L from "./util/L10n";
import Columns from './teaserlayout/Columns';
import PageTitleItem from './components/PageTitleItem';

import PageHelmet from './util/PageHelmet';

import Config from './config/ui_settings.json';
import CanonicalUrl from "./util/CanonicalUrl";
import DpaLinkItem from "./cards/DpaLinkItem";
import Divider from "@material-ui/core/Divider";
import DpaInfoCard from "./cards/DpaInfoCard";
import "./fgfStyles.css"

const useStyles = makeStyles((_) => ({}));
const name = "Aus aller Welt";


class Section {
    color = null;
    title = null;
    postions = [];

}

class DpaNewsPage extends PureComponent {
    constructor(props) {
        super(props);
        const historyState = props.location.state || {};
        const {dpaLastModified} = historyState;
        let {dpaData} = historyState;

        if (dpaData && !(typeof dpaData[Symbol.iterator] === 'function')) {
            dpaData = null;
        }
        let level;
        if (props.routing) {
            level = props.routing.match.params.level;
        }

        this.state = {
            level: level,
            error: null,
            dpaData: dpaData || null,
            dpaLastModified: dpaLastModified || null,
            userLang: props.userLang,
        };
        this.onDpaDataReceived = this._onDpaDataReceived.bind(this);
    }

    componentDidMount() {
        try {
            window.scrollTo(0, 0);
        } catch (e) {
            // Ignore.
        }
        this.load();
    }

    componentDidUpdate() {
        if (this.state.userLang !== this.props.userLang) {
            this.setState({userLang: this.props.userLang,});
            this.load();
        }
    }

    load() {
        const {
            appServerPort, previewToken, previewDate,
        } = this.props;
        const {dpaData, dpaLastModified} = this.state;
        const lang = 'de';

        if (!dpaData) {
            getViewData("dpaposts", lang, this.onDpaDataReceived,
                appServerPort, previewToken,
                previewDate).catch((error) => {
                //console.log(error)
                this.setState({error: error})
            });
        } else {
            headViewData("dpaposts", lang, this.onDpaDataReceived,
                appServerPort, previewToken,
                previewDate, dpaLastModified).catch((error) => {
                //console.log(error)
                this.setState({error: error})
            });
        }


    }


    _onDpaDataReceived(dpaData, dpaLastModified) {
        const {history, location} = this.props;
        const state = location.state || {};
        state.dpaData = dpaData;
        state.dpaLastModified = dpaLastModified;
        history.replace({state});
        this.setState({dpaData: dpaData, dpaLastModified: dpaLastModified, error: null})
    }

    render() {
        const {userLang,} = this.props;
        if (this.state.error) {
            return (
                <Grid container direction='row' justify='center' alignItems='center' spacing={Config.gridSpacing}>
                    {this.buildHeader()}
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant='subtitle1' component='span'>
                                {L.t('msgTeaserPageFailed', userLang)}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            );
        } else if (this.state.dpaData) {
            return (
                <div>
                    {this.renderContent()}
                </div>

            );
        } else {
            return (
                <Grid container direction='row' justify='center' alignItems='center' spacing={Config.gridSpacing}>
                    {this.buildHeader()}
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant='subtitle1' component='span'>
                                {L.t('msgTeaserPageLoading', userLang)}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            );
        }
    }

    renderContent() {
        const {twoColumnLayout, textOnly} = this.props;
        let result = [];
        let sections = this.buildSections();
        result.push((
            <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={Config.gridSpacing}>
                {this.buildHeader()}
            </Grid>
        ));

        let extraPadding = 16;
        let firstSection = true;
        for (let section of sections) {
            const columns = this.buildPositions(section.postions);
            let style

            if (section.color == null) {
                if (section.title != null && section.title.trim().length > 0) {
                    style = {
                        backgroundColor: "transparent",
                        paddingLeft: extraPadding,
                        paddingRight: extraPadding,
                        paddingBottom: 0,
                        paddingTop: firstSection ? 8 : 0,
                        marginLeft: -8 - extraPadding,
                        marginRight: -8 -extraPadding,
                        width: "calc(100% + "+ (16 + 2 * extraPadding) + "px)",
                    };
                } else {
                        style = {
                            backgroundColor: "transparent",
                            paddingLeft: extraPadding,
                            paddingRight: extraPadding,
                            paddingTop: firstSection ? 12 : 0,
                            marginLeft: -8 - extraPadding,
                            marginRight: -8 - extraPadding,
                            width: "calc(100% + "+ (16 + 2 * extraPadding) + "px)",
                            };
                }


            } else {
                if (section.title != null && section.title.trim().length > 0) {
                    style = {
                        backgroundColor: section.color,
                        paddingLeft: extraPadding,
                        paddingRight: extraPadding,
                        paddingBottom: extraPadding,
                        borderRadius: twoColumnLayout ? extraPadding : 0,
                        marginTop: 8 + extraPadding,
                        marginBottom: 8 + extraPadding,
                        marginLeft: -8 - extraPadding,
                        marginRight: -8 - extraPadding,
                        width: "calc(100% + "+ (16 + 2 * extraPadding) + "px)",
                    };
                } else {
                    style = {
                        backgroundColor: section.color,
                        padding: extraPadding,
                        borderRadius: twoColumnLayout ? extraPadding : 0,
                        marginTop: 8 + extraPadding,
                        marginBottom: 8 + extraPadding,
                        marginLeft: -8 - extraPadding,
                        marginRight: -8 - extraPadding,
                        width: "calc(100% + "+ (16 + 2 * extraPadding) + "px)",
                    };
                }

            }
            result.push((
                <Grid container direction='row' justify='flex-start' alignItems='stretch'
                      spacing={Config.gridSpacing} style={style}>
                    {(twoColumnLayout && !textOnly) ? columns.getDouble() : columns.getSingle()}
                </Grid>
            ));
            firstSection = false;
        }
        return result;

    }

    buildHeader() {
        const {
            previewToken, previewDate,
            userLang, updateUserLang, documentTitle,
        } = this.props;
        const {
            description, canonicalUrl, ogLocale, ogType, searchable,
        } = this.buildMetaData();



        return (
            <Fragment>
                <PageHelmet
                    documentTitle={documentTitle}
                    metaDescription={description}
                    canonicalUrl={canonicalUrl}
                    ogTitle={documentTitle}
                    ogDescription={description}
                    ogUrl={canonicalUrl}
                    ogLocale={ogLocale}
                    ogType={ogType}
                    noIndex={!searchable}
                />
                <PageTitleItem
                    name={"dpaSchlagzeilen"}
                    previewToken={previewToken}
                    previewDate={previewDate}
                    userLang={userLang}
                    updateUserLang={updateUserLang}
                    hideDate={true}
                />
                <div style={{paddingTop: "36px", width: "100%"}}></div>
                <Divider style={{height: 2, width: "100%", backgroundColor:'#D9D9D9'}}/>
                <div style={{paddingTop: "12px", width: "100%"}}></div>            </Fragment>
        );
    }

    buildMetaData() {
        let description = "documentTitle";

        let canonicalUrl;
        let searchable = true;

        canonicalUrl = CanonicalUrl.get("dpa-news");


        // TODO The content locale is fixed to German, therefore, the locale
        // if fixed here, too.
        const ogLocale = 'de_DE';
        const ogType = 'website';
        return {description, canonicalUrl, ogLocale, ogType, searchable};
    }

    buildSections() {
        let sections = [];
        let section = new Section();

                if (section.postions.length > 1) {
                    sections.push(section);
                    section = new Section();
                }
                section.title = name; //position.title;
                //todo section.postions.push(position);
                var postion = {};
                postion.type = "dpaheadlines";
                section.postions.push(postion);
                sections.push(section);
                section = new Section();


        if (section.postions.length > 1) {
            sections.push(section);
        } else if(section.postions.length === 1 && section.color == null) {
            section.title = null;
            sections.push(section);

        }
        return sections;
    }

    buildPositions(positions) {
        const columns = new Columns();
        let pos = 0;
        for (let position of positions) {
            if (position.type) {
                if ("dpaheadlines" === position.type && this.state.dpaData) {
                    columns.addSection(this.buildDpaHeadlinesSection(
                        pos, position.title, this.state.dpaData));
                }
            }
            pos++;
        }
        columns.finish();
        return columns;
    }


    buildDpaHeadlinesSection(pos, title, dpaData) {
        const dividerStyle =  <Divider style={{height: 2, width: "100%", backgroundColor:'#D9D9D9'}}/>;

        let titleGrids;
        let grids = [];
        let cardno = 0;
        //let style = {};



        let singleTitle = null;
        let doubleTitle = null;
        titleGrids = [singleTitle, doubleTitle];

        let styleParent = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: "100%",
        }
        let stylePadding = {
            paddingTop: 0,
            paddingBottom: 0,
            marginTop:-16,

        }

        let headerMore = <div className={"h3"}>WEITERE NACHRICHTEN</div>;

        for (let dpaEntry of dpaData) {

            let card = <DpaLinkItem title={dpaEntry.title} url={"/entry/" + dpaEntry.id}/>;
            let doubleDiv = null;
            let doublePadding = null;
            let singleDiv = null;
            let singlePadding = null;
            if (cardno === 0 || cardno === 1) {
                doubleDiv = dividerStyle
                doublePadding = <div style={{paddingBottom:16}}></div>
            }

            if (cardno === 0) {
                singleDiv = dividerStyle
                singlePadding = <div style={{paddingBottom:16}}></div>
            }

            let header = null;
            let headerDiv = null;
            let headerPaddingTop = null;
            let headerPaddingBottom = null;
            let headerDivPaddingBottom = null;
            if(cardno === 3) {
                headerDiv = dividerStyle;
                header = headerMore;
                headerPaddingTop = <div style={{paddingBottom: 32}}></div>;
                headerPaddingBottom = <div style={{paddingBottom:16}}></div>;
                headerDivPaddingBottom = <div style={{paddingBottom:16}}></div>;
            }

            //single
            let single = null;
            let lastDivider =  dividerStyle;
            if(cardno === dpaData.length - 1) {
                lastDivider = null;
            }

            if (cardno > 2) {
                single = <Grid
                    item xs={12}
                    key={'gridpos' + pos + 'grid' + cardno}
                >

                    <div style={styleParent}>
                        {headerPaddingTop}
                        {header}
                        {headerPaddingBottom}
                        {headerDiv}
                        {headerDivPaddingBottom}

                        {singleDiv}

                        <div style={stylePadding}>
                            {singlePadding}
                            {card}
                        </div>
                        {lastDivider}
                    </div>
                </Grid>;

            } else {
                single = <Grid
                    item xs={12}
                    key={'gridpos' + pos + 'grid' + cardno}
                >
                    <div style={styleParent}>
                        <DpaInfoCard
                            entry={dpaEntry}

                        />
                        {dividerStyle}
                    </div>
                </Grid>;
            }


            // double
            let double = null;
            let endDobuleDivider = dividerStyle;

            if (cardno > 1) {
                endDobuleDivider = null;
            }

            let fristSingleDivider = null;
            let fristSingleDividerPadding = null;
            let singleHeader = null;
            let singleHeaderDividerPadding = null;
            if(cardno === 4) {
                fristSingleDivider = dividerStyle;
                singleHeaderDividerPadding = <div style={{paddingBottom:48}}></div>
                fristSingleDividerPadding = <div style={{paddingBottom:16}}></div>
                singleHeader = headerMore;

            }
            let lastSingelDivider =dividerStyle;
            if(cardno === dpaData.length - 1) {
                lastSingelDivider = null;
            }


            if (cardno > 3) {
                double = <Grid
                    item xs={12}
                    key={'gridpos' + pos + 'grid' + cardno}
                >
                    <div style={styleParent}>
                        {doubleDiv}
                        {fristSingleDivider}
                        {singleHeaderDividerPadding}
                        {singleHeader}
                        {fristSingleDividerPadding}
                        {fristSingleDivider}
                        {fristSingleDividerPadding}

                        <div style={stylePadding}>
                            {doublePadding}
                            {card}
                        </div>
                        {lastSingelDivider}
                    </div>
                </Grid>;
            } else {
                double = <Grid
                    item xs={6}
                    key={'gridpos' + pos + 'grid' + cardno}>
                    <div style={{display: "flex",flexDirection: "column", justifyContent: "space-between", height: "100%", alignItems: "center", paddingBottom:8}}>
                        <div style={stylePadding}>
                            {doublePadding}
                            <DpaInfoCard
                                entry={dpaEntry}

                            />

                        </div>
                        {endDobuleDivider}

                    </div>
                </Grid>

            }



            grids.push([single, double]);
            cardno++;
        }


        return [titleGrids, grids];
    }

    getTeaser(dpaEntry) {
        var count = dpaEntry.kacheln.length;
        for(var i = 0; i < count; i++) {
            var kachel = dpaEntry.kacheln[i];
            if(kachel.type === "uestra/dpa-infoline-entry") {
                return kachel.teaser;
            }
        }
        return "";
    }

    getFirstImage(dpaEntry) {
        var count = dpaEntry.kacheln.length;
        for(var i = 0; i < count; i++) {
            var kachel = dpaEntry.kacheln[i];
            if(kachel.type === "uestra/dpa-infoline-image") {
                return kachel.mediaURL;
            }
        }
        return "";
    }


}

DpaNewsPage.propTypes = {
    classes: PropTypes.object,
    twoColumnLayout: PropTypes.bool,
    appServerPort: PropTypes.number,
    previewToken: PropTypes.string,
    previewDate: PropTypes.string,
    userLang: PropTypes.string,
    updateUserLang: PropTypes.func,
    deviceSize: PropTypes.string,
    documentTitle: PropTypes.string,
    textOnly: PropTypes.bool,
    routing: PropTypes.object,
}

DpaNewsPage.defaultProps = {
}

export default withRouter((props) => {
    const classes = useStyles();
    const theme = useTheme();
    const isLandscape = useMediaQuery('@media (orientation: landscape)');
    const isWideScreen =
        useMediaQuery(theme.breakpoints.up(Config.teaserWidescreenMinWidth));
    const twoColumnLayout = isLandscape || isWideScreen;
    let documentTitle = name +
        ' - ' + L.t('appTitle', props.userLang);


    const {trackPageView,} = useMatomo();
    React.useEffect(() => {
        trackPageView({documentTitle,});
    }, [trackPageView, documentTitle]);
    return <DpaNewsPage
        {...props}
        classes={classes}
        twoColumnLayout={twoColumnLayout}
        documentTitle={documentTitle}
    />;
});
